export default "__VITE_ASSET__FsNAZati__"